import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: theme.palette.common.white,
    },
}));

interface IOntimeProgressProps {
    message?: string;
    open: boolean;
}
function OntimeProgress(props: IOntimeProgressProps) {
    const classes = useStyles();
    return (
        <Backdrop className={classes.backdrop} open={props.open} >
            <Box display="flex" alignItems="center">
                {props.message ? (<Box><Typography>{props.message}</Typography></Box>) : (<></>)}
                <Box>
                    <CircularProgress color="inherit" />
                </Box>
            </Box>
        </Backdrop>);
}

export default OntimeProgress;